import { render, staticRenderFns } from "./xiugaiDizhi.vue?vue&type=template&id=9b7bedbc&scoped=true&"
import script from "./xiugaiDizhi.vue?vue&type=script&lang=js&"
export * from "./xiugaiDizhi.vue?vue&type=script&lang=js&"
import style0 from "./xiugaiDizhi.vue?vue&type=style&index=0&id=9b7bedbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7bedbc",
  null
  
)

export default component.exports